import { render, staticRenderFns } from "./Opendata.vue?vue&type=template&id=278a03e0"
import script from "./Opendata.vue?vue&type=script&lang=js"
export * from "./Opendata.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports